import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import TemplateFilter from "./TemplateFilter";
import TemplateList from "./TemplateList";
import TemplateFields from "./TemplateFields";
import GeneralFields from "./GeneralFields";
import FieldFooter from "./FieldFooter";
import NoTemplateSelected from "./NoTemplateSelected";
import TemplateEmpty from "./TemplateEmpty";
import NoTemplateAdded from "./NoTemplateAdded";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";

import {
  getAllTemplate,
  setTemplate,
  removeTemplate,
  templateSelector,
  templatesSelector,
  updateTemplate,
  deleteTemplate,
  addTemplate,
  addNewTemplate,
  getTemplate,
} from "../../../redux/templateSlice";
import { api } from "../../../services/api-service";
import { format } from "date-fns";

import { error } from "../../../redux/notificationSlice";
const TemplateMain = () => {
  const dispatch = useDispatch();
  const templates = useSelector(templatesSelector);
  const template = useSelector(templateSelector);
  const { state } = useLocation();
  const { id } = useParams();
  const searchTimeout = useRef();
  const tempRef = useRef();
  const [fields, setFields] = useState([]);
  const [edit, setEdit] = useState(false);
  const [nameAdded, setNameAdded] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getFields();
    if (id) {
      getOneTemplate(id);
    }
  }, [id]);

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      dispatch(getAllTemplate({ search }));
    }, 500);
  }, [search]);

  const getOneTemplate = async (id) => {
    const response = await api.get(`get-template/${id}`);
    if (response && response.ok) {
      handleSelected(response.data.data);
    }
  };

  useEffect(() => {
    if (state?.isNew) {
      addTemplate_Click();
    }
  }, [state?.isNew]);

  const addTemplate_Click = () => {
    onClickCancelHandler();
    tempRef.current?.focus();
    setEdit(true);
    handleFields({});
    setIsSelected(true);
  };

  const getFields = async () => {
    const surveyorFields = await api.get("get-fields?type=surveyor");
    const fields = await api.get("get-fields?type=");
    if (surveyorFields.ok && fields.ok) {
      setFields([
        ...fields.data.data,
        ...surveyorFields.data.data,
        {
          id: "b9daa2dc-de52-4eae-a0a3-fc297a4d9dfa",
          title: "NIA/GIA/GEA",
          isRequired: false,
          role: "surveyor",
        },
      ]);
    }
  };

  const handleSelected = (e) => {
    setNameAdded(true);
    setEdit(false);
    handleFields(e);
    dispatch(setTemplate(e));
    setIsSelected(true);
  };

  const handleFields = (e) => {
    setFields(
      fields.map((field) => {
        const temp = { ...field };
        const included = e?.fields
          ? e.fields.find((item) => item.id === temp.id)
          : null;
        if (included) {
          temp.isIncluded = included.isIncluded;
        } else {
          temp.isIncluded = false;
        }
        return temp;
      })
    );
  };

  const handleSubmit = () => {
    if (template.name && template.name.trim() !== "") {
      if (template.id) {
        updatedTemplate();
      } else {
        addLTemplate();
      }
    } else {
      dispatch(error("Please add survey name"));
    }
  };

  const addLTemplate = async () => {
    const updated = {
      ...template,
      fields: fields
        .filter((field) => field.isIncluded)
        .map((item) => {
          return { id: item.id, isIncluded: item.isIncluded };
        }),
    };
    setEdit(false);
    dispatch(addNewTemplate(updated));
  };

  const updatedTemplate = () => {
    const updated = {
      ...template,
      fields: fields
        .filter((field) => field.isIncluded)
        .map((item) => {
          return { id: item.id, isIncluded: item.isIncluded };
        }),
    };
    setEdit(false);
    dispatch(updateTemplate(updated));
  };

  const onClickCancelHandler = () => {
    setEdit(false);
    setNameAdded(false);
    setIsSelected(false);
    dispatch(removeTemplate({}));
  };

  return (
    <div className="main-dashboard">
      <div className="mainWrapper">
        <Row className="g-0">
          <Col lg="4">
            <div className="sidebarTemplate">
              <div className="template-header">
                <h3>
                  Templates
                  <Link className="ctaAdd" to="#" onClick={addTemplate_Click}>
                    <Icon icon="ic:outline-plus" />
                  </Link>
                </h3>
                <TemplateFilter text={search} onChange={(e) => setSearch(e)} />
              </div>
              <div className="template-body ">
                {templates.data && templates.data.length > 0 ? (
                  <TemplateList
                    selected={template}
                    onSelect={(e) => handleSelected(e)}
                  />
                ) : (
                  <NoTemplateAdded
                    selected="No template added"
                    addNew="Add new template"
                    content="It seems like you have not created any template yet! Create one and view the content here."
                    onAdd={addTemplate_Click}
                  />
                )}
              </div>
            </div>
          </Col>
          <Col lg="8">
            {isSelected ? (
              <div className="templateCard">
                {(isSelected || templates.count > 0) && (
                  <div className="template-title">
                    <div className="media-body">
                      <div className="titleBox">
                        {edit ? (
                          <>
                            <div className="fieldEdit">
                              <div className="relative">
                                <Form
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    setNameAdded(true);
                                    setEdit(false);
                                  }}
                                >
                                  <Form.Control
                                    type="text"
                                    ref={tempRef}
                                    required
                                    placeholder="Insert Title"
                                    autoFocus
                                    value={template.name || ""}
                                    onKeyUp={(e) =>
                                      setNameAdded(e.target.value.trim() !== "")
                                    }
                                    onChange={(e) =>
                                      dispatch(
                                        addTemplate({
                                          type: "name",
                                          value: e.target.value,
                                        })
                                      )
                                    }
                                  />
                                  {/* <i></i> */}
                                </Form>
                                {/*     <button
                              className="cta-close"
                              onClick={() => setEdit(false)}
                            >
                              <Icon icon="mdi:window-close" />
                            </button> */}
                              </div>
                              {/*   <button
                            onClick={() => setEdit(false)}
                            className="btn cta-primary"
                          >
                            Save
                    </button> */}
                            </div>
                          </>
                        ) : (
                          <h3>
                            {template?.name}
                            <Link
                              to="#"
                              onClick={() => setEdit(true)}
                              className="cta"
                            >
                              <Icon icon="carbon:edit" />
                            </Link>
                          </h3>
                        )}
                      </div>
                      <p>
                        <span>Survey template</span>
                        {template.createdOn &&
                          format(new Date(template.createdOn), "MMM dd, yyyy")}
                      </p>
                    </div>

                    {template.id && !template.isSystemTemplate && (
                      <Link
                        to="#"
                        onClick={() => {
                          setIsSelected(false);
                          dispatch(deleteTemplate(template));
                        }}
                        className="cta-square warning"
                      >
                        <Icon icon="octicon:trash-16" />
                      </Link>
                    )}
                  </div>
                )}
                {templates.data?.length > 0 || isSelected ? (
                  <>
                    <div className="templateBody ptcst">
                      <div
                        className={`templatesFields ${
                          !nameAdded ? "active" : ""
                        }`}
                      >
                        {/*     <div className="alertNote primaryAlert mb-3">
                      <div className="icon">
                        <Icon icon="fluent-emoji-high-contrast:information" />
                      </div>
                      <div className="media-body">
                        <p>
                          Some of the default fields will not be displayed while
                          creating the template, in order to view the fields
                          which will be included with this template, click the
                          button next to this note to see those fields.
                        </p>
                      </div>
                      <Link to="#" className="btn cta-white">
                        View
                      </Link>
                    </div> */}

                        <TemplateFields
                          fields={fields}
                          setFields={(e) => setFields(e)}
                        />
                        <GeneralFields
                          fields={fields}
                          setFields={(e) => setFields(e)}
                        />
                      </div>
                      <FieldFooter
                        disabled={!nameAdded}
                        createTemplate={handleSubmit}
                        cancelHandler={onClickCancelHandler}
                      />
                    </div>
                  </>
                ) : (
                  <TemplateEmpty />
                )}
              </div>
            ) : (
              <>
                <TemplateEmpty />
              </>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TemplateMain;
